import React, { useState, useEffect } from 'react';

// Lightweight, high-performance animated counter component using requestAnimationFrame
const AnimatedCounter = ({ target, duration = 2000, decimals = 0, suffix = "" }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let startTime = null;
    const start = 0;
    const end = parseFloat(target);
    if (isNaN(end)) return;

    const animate = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = timestamp - startTime;
      const progressPercentage = Math.min(progress / duration, 1);
      
      // Smooth Easing out function
      const easeOutQuad = (t) => t * (2 - t);
      const easedProgress = easeOutQuad(progressPercentage);

      const currentValue = start + easedProgress * (end - start);
      setCount(currentValue);

      if (progress < duration) {
        requestAnimationFrame(animate);
      } else {
        setCount(end);
      }
    };

    requestAnimationFrame(animate);
  }, [target, duration]);

  const formattedCount = count.toFixed(decimals);
  const formattedString = decimals === 0 
    ? parseInt(formattedCount, 10).toLocaleString() 
    : formattedCount;

  return <span>{formattedString}{suffix}</span>;
};

function Counters({ data }) {
  const defaultData = [
    { target: 1000, suffix: "+", text: "Projects completed" },
    { target: 4.8, decimals: 1, text: "Success ratio" },
    { target: 150, suffix: "+", text: "Number of clients" },
    { target: 99, suffix: "%", text: "Client satisfaction" }
  ];

  const items = data || defaultData;

  return (
    <section className="counters-section">
      <div className="container counters-container">
        {items.map((item, index) => (
          <React.Fragment key={index}>
            <div className="counter-box">
              {item.icon && (
                <div className="counter-icon-wrapper">
                  {item.icon}
                </div>
              )}
              <div className="counter-details-wrapper">
                <span className="counter-number">
                  <AnimatedCounter 
                    target={item.target} 
                    decimals={item.decimals || 0} 
                    suffix={item.suffix || ""} 
                  />
                </span>
                <span className="counter-text">{item.text}</span>
              </div>
            </div>
            {index < items.length - 1 && <div className="counter-divider"></div>}
          </React.Fragment>
        ))}
      </div>
    </section>
  );
}

export default Counters;
